/*
 * MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
 * Email: mythpe@gmail.com
 * Mobile: +966590470092
 * Website: https://www.4myth.com
 */

export default {
  methods: {
    openDownloadApp (payload = {}) {
      // console.log(payload, this.$route)
    },
    downloadGooglePlay (payload = {}) {
      const url = this.AppSettings?.play_store_url
      if (url) {
        window.open(url, 'windowDownload')
      }
    },
    downloadAppStore (payload = {}) {
      const url = this.AppSettings?.app_store_url
      if (url) {
        window.open(url, 'windowDownload')
      }
    }
  },
  computed: {}
}
